var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finTools"},[(this.$route.name === 'finTools')?_c('div',[_c('fin-content-section',{attrs:{"elevated":""}},[[_c('fin-tools-overview',{attrs:{"tabs":_vm.tabs,"id":"fin-tools-overview"}})]],2)],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }